"use strict";
/** @jsx jsx */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("react-datepicker/dist/react-datepicker.css");
require("./styles.css");
const carabiners_1 = require("@clearsummit/carabiners");
const core_1 = require("@emotion/core");
const react_1 = __importDefault(require("react"));
const react_datepicker_1 = __importDefault(require("react-datepicker"));
const __1 = require("..");
const styles_1 = __importDefault(require("./styles"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const DatePicker = (_a) => {
    var { className, error } = _a, rest = __rest(_a, ["className", "error"]);
    return (core_1.jsx(react_1.default.Fragment, null,
        core_1.jsx(react_datepicker_1.default, Object.assign({}, rest, { className: carabiners_1.joinStr(styles_scss_1.default.datePicker, className), css: styles_1.default.datePicker(error), popperPlacement: "bottom-start", autoComplete: "off" })),
        core_1.jsx(__1.HelperText, { className: styles_scss_1.default.error }, error || "")));
};
exports.default = DatePicker;
